import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getAlarmTypeList = async () => {
  return axios.get(`${api_base_url}/GetAlarmType`).then((res) => {
    return res;
  });
};

export const addAlarmType = async (newAlarmType) => {
  const { data } = await axios.post(`${api_base_url}/AddAlarmType`, {
    ...newAlarmType,
  });
  return data;
};

export const deleteAlarmType = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateAlarmtype`, {
    data: ids,
  });

  return data;
};

export const updateAlarmType = async (editAlarmTypeData) => {
  const { data } = await axios.put(`${api_base_url}/EditAlarmType`, editAlarmTypeData);
  return data;
};
